import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import Navbar from "@/components/Navbar";

const ThankYou = () => (
  <div className="min-h-screen bg-slate-50">
    <Navbar />
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-6">
        <Calendar className="w-7 h-7 text-blue-600" />
      </div>
      <h1 className="font-display text-4xl font-bold tracking-tighter text-slate-900">Thank you.</h1>
      <p className="mt-4 text-lg text-slate-600">Your readiness results appear on the previous screen. To discuss these findings, schedule a 30-minute Enterprise Alignment Review with The River Company.</p>
      <div className="mt-8 flex justify-center gap-3 flex-wrap">
        <Button asChild className="bg-blue-600 hover:bg-blue-700 text-white rounded-md px-6">
          <a href="https://calendly.com/paul-therivercompany/30min" target="_blank" rel="noopener noreferrer">Schedule a 30-minute Enterprise Alignment Review</a>
        </Button>
        <Button variant="outline" asChild className="border-slate-300 rounded-md px-6">
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </div>
  </div>
);

export default ThankYou;
